<template>
    <!-- Add Shipping Modal -->
    <div class="modal fade" id="shippingTrackingModal" ref="shippingTrackingModal" tabindex="-1"
         aria-labelledby="shippingModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="shippingModalLabel"> Shipping Details</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class=" shipment-info top-info" v-if="shippingByRef">
                                <div class="container cont-fluid-wrapper">
                                    <div class="shipment-info-general-wrapper">
                                        <div class="row shipment-info-general-header-wrapper">
                                            <div class="col col-6">
                                                <div class="info-title">General Information</div>
                                            </div>
                                            <div class="col col-6"></div>
                                        </div>
                                        <div class="row shipment-info-general-content-wrapper">
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="original-width">MBL #</div>
                                                    <div class="original-width"><span>{{shippingByRef['MBL#']}}</span></div>
                                                </div>
                                            </div>
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="longer-width">Booking #</div>
                                                    <div class="longer-width"><span>{{shippingByRef['Booking#']}}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row shipment-info-general-content-wrapper">
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="original-width">From &amp; ETD</div>
                                                    <div class="original-width">
                                                        <span>{{shippingByRef['POL']}}, </span><span
                                                        style="color: rgb(1, 113, 161);">{{formatDate(shippingByRef['Current ETD'])}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="longer-width">Custom Ref#</div>
                                                    <div class="longer-width">
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row shipment-info-general-content-wrapper">
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="original-width">To &amp; ETA</div>
                                                    <div class="original-width"><span>{{shippingByRef['POD']}}, </span><span
                                                        style="color: rgb(1, 113, 161);">{{formatDate(shippingByRef['Current ETA'])}}</span></div>
                                                </div>
                                            </div>
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="longer-width">Carrier</div>
                                                    <div class="longer-width"><span>{{shippingByRef['Carrier']}}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row shipment-info-general-content-wrapper">
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="original-width">Mode &amp; Type</div>
                                                    <div class="d-flex align-center original-width"><!---->
                                                        <div><span style="color: rgb(74, 74, 74);">{{shippingByRef['Mode']}} {{shippingByRef['Type']}}</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="longer-width">Vessel &amp; Voyage</div>
                                                    <div class="longer-width">
                                                        <span>{{shippingByRef['Vessel Name']}}</span><span>, {{shippingByRef['Voyage#']}}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row shipment-info-general-content-wrapper">
                                            <div class="col col-6">
                                                <div class="shipment-info-general-label">
                                                    <div class="longer-width">Terminal</div>
                                                    <div class="longer-width"><span>N/A</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div><!---->
                                    <div class="row shipment-info-wrapper"><!----><!----><!----></div><!----></div>
                                <!---->  <!----><!---->
                                <div class="shipment-info milestone-container-wrapper"><!---->
                                    <div class="tracking-containers"><!---->
                                        <div>
                                            <div class="has-tracking-containers">
                                                <hr role="separator" aria-orientation="horizontal"
                                                    class="shipment-info-divider v-divider theme--light">
                                                <h3 class="container-title">Containers</h3>
                                                <div class="container cont-fluid-wrapper container--fluid">
                                                    <div class="container-grid">
                                                        <div
                                                            class="v-data-table elevation-1 container-table theme--light">
                                                            <div class="v-data-table__wrapper">
                                                                <table>
                                                                    <colgroup>
                                                                        <col class="">
                                                                        <col class="">
                                                                        <col class="">
                                                                        <col class="">
                                                                    </colgroup>
                                                                    <thead class="v-data-table-header">
                                                                    <tr>
                                                                        <th role="columnheader" scope="col"
                                                                            aria-label="#SL" class="text-start"
                                                                            style="width: 6%; min-width: 6%;">
                                                                            <span>#SL</span></th>
                                                                        <th role="columnheader" scope="col"
                                                                            aria-label="NUMBER" class="text-start"
                                                                            style="width: 20%; min-width: 20%;"><span>NUMBER</span>
                                                                        </th>
                                                                        <th role="columnheader" scope="col"
                                                                            aria-label="SIZE" class="text-right"
                                                                            style="width: 15%; min-width: 15%;"><span>SIZE</span>
                                                                        </th>
                                                                        <th role="columnheader" scope="col"
                                                                            aria-label="WEIGHT" class="text-right"
                                                                            style="width: 18%; min-width: 18%;"><span>WEIGHT</span>
                                                                        </th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    <tr class="">
                                                                        <td class="text-start">01</td>
                                                                        <td class="text-start">{{shippingByRef['Container#']}}</td>
                                                                        <td class="text-right"><span>{{shippingByRef['Container Sizes']}}</span></td>
                                                                        <td class="text-right"><span>{{shippingByRef['Container Weight (kg)'] != '' ? shippingByRef['Container Weight (kg)'] : 0.00}} KG</span></td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div><!----></div>
                                            </div>
                                        </div>
                                    </div>
                                </div><!----><!----></div>
                        </div>
                        <div class="col-md-4"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";


export default {
    name: "ShippingTrackingModal",
    props: ['shipping', 'order', 'loading', 'carriers', 'shippingByRef', 'shippingStatus'],
    components: {},
    created() {
    },
    mounted() {
        let self = this;

        $("#shippingTrackingModal").on('show.bs.modal', () => {

        });

        $(this.$refs.shippingTrackingModal).on('hidden.bs.modal', function () {

        });
    },
    data() {
        return {};
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),

    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {}
}
</script>

<style scoped>

</style>
